"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _SimpleStyledCaret = _interopRequireDefault(require("../internal/SimpleStyledCaret"));

var _SimpleStyledClickable = _interopRequireDefault(require("../internal/SimpleStyledClickable"));

var _UIIconButton = _interopRequireDefault(require("../../button/UIIconButton"));

var _Selectors = require("../../constants/Selectors");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _UIAbstractDropdown = _interopRequireDefault(require("../../dropdown/abstract/UIAbstractDropdown"));

var _UITextToolbarIcon = _interopRequireDefault(require("../../editor/UITextToolbarIcon"));

var _UIList = _interopRequireDefault(require("../../list/UIList"));

var _OptionTypes = require("../../types/OptionTypes");

var _Dom = require("../../utils/Dom");

var _underscore = require("../../utils/underscore");

var getDropdownClassName = function getDropdownClassName(dropdownClassName) {
  return (0, _classNames.default)('private-dropdown--list', dropdownClassName);
};

var UIAbstractIconDropdown =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIAbstractIconDropdown, _Component);

  function UIAbstractIconDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAbstractIconDropdown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAbstractIconDropdown).call(this, props));
    _this._id = "icon-dropdown-" + (0, _underscore.uniqueId)();
    _this.getHandleChange = (0, _memoize.default)(_this.getHandleChange.bind((0, _assertThisInitialized2.default)(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIAbstractIconDropdown, [{
    key: "getHandleChange",
    value: function getHandleChange(value) {
      var _this2 = this;

      var event = (0, _SyntheticEvent.default)(value);
      return function () {
        var _this2$props = _this2.props,
            onOpenChange = _this2$props.onOpenChange,
            onChange = _this2$props.onChange,
            open = _this2$props.open;
        onChange(event);
        onOpenChange((0, _SyntheticEvent.default)(!open));
      };
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt) {
      var key = evt.key;
      var open = this.props.open;
      if (!open) return;

      if (key === 'ArrowDown' || key === 'ArrowUp') {
        var dropdownList = document.getElementById(this._id);
        if (!dropdownList) return;
        var allDropdownItems = dropdownList.querySelectorAll('li');
        if (allDropdownItems.length === 0) return;
        var currentItem = (0, _Dom.closest)(document.activeElement, 'li');
        var nextItem = key === 'ArrowDown' ? currentItem && currentItem.nextSibling || allDropdownItems[0] : currentItem && currentItem.previousSibling || (0, _underscore.last)(allDropdownItems);

        while (nextItem !== currentItem) {
          var focusTarget = nextItem.querySelector(_Selectors.FOCUSABLE);

          if (focusTarget) {
            evt.preventDefault();
            focusTarget.focus();
            break;
          }

          nextItem = key === 'ArrowDown' ? nextItem.nextSibling || allDropdownItems[0] : nextItem.previousSibling || (0, _underscore.last)(allDropdownItems);
        }

        evt.stopPropagation();
      }
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(options) {
      var _this3 = this;

      return options.map(function (_ref) {
        var icon = _ref.icon,
            value = _ref.value;
        return _react.default.createElement(_UIIconButton.default, {
          key: icon,
          onClick: _this3.getHandleChange(value),
          placement: "left",
          use: "unstyled"
        }, _react.default.createElement(_UITextToolbarIcon.default, {
          name: icon
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dropdownClassName = _this$props.dropdownClassName,
          open = _this$props.open,
          options = _this$props.options,
          __value = _this$props.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["dropdownClassName", "open", "options", "value"]);
      var computedDropdownClassName = getDropdownClassName(dropdownClassName);
      return _react.default.createElement(_UIAbstractDropdown.default, (0, _extends2.default)({}, rest, {
        Button: _SimpleStyledClickable.default,
        caretRenderer: _react.default.createElement(_SimpleStyledCaret.default, null),
        dropdownClassName: computedDropdownClassName,
        menuWidth: 50,
        open: open,
        onKeyDown: this.handleKeyDown
      }), _react.default.createElement(_UIList.default, {
        id: this._id
      }, this.renderOptions(options)));
    }
  }]);
  return UIAbstractIconDropdown;
}(_react.Component);

UIAbstractIconDropdown.propTypes = (0, _extends2.default)({}, _UIAbstractDropdown.default.propTypes, {
  defaultValue: _OptionTypes.SingleValueType,
  dropdownClassName: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func,
  open: _react.PropTypes.bool.isRequired,
  options: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    icon: _UITextToolbarIcon.default.propTypes.name,
    value: _OptionTypes.SingleValueType
  }).isRequired).isRequired,
  value: _OptionTypes.SingleValueType
});
UIAbstractIconDropdown.defaultProps = (0, _extends2.default)({}, _UIAbstractDropdown.default.defaultProps, {
  open: false
});
UIAbstractIconDropdown.displayName = 'UIAbstractIconDropdown';
var _default = UIAbstractIconDropdown;
exports.default = _default;
module.exports = exports.default;